import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import usePageMeta from "../hooks/usePageMeta";
import Footer from "../components/Footer";
import ContactCTA from "../components/ContactCTA";
import { Phone, Shield, Brain, ArrowRight } from "lucide-react";

const products = [
  { icon: Brain, key: "skyglobalAi", color: "text-purple-600", bgColor: "bg-purple-50" },
  { icon: Shield, key: "secure", color: "text-red-600", bgColor: "bg-red-50" },
  { icon: Phone, key: "smartLiving", color: "text-textBlue", bgColor: "bg-blueLight" },
];

export default function Products() {
  const { t } = useTranslation();
  usePageMeta({
    title: "Products | Sky Global",
    description: t("products.title"),
    path: "/products",
  });

  return (
    <>
      {/* Header */}
      <section className="relative overflow-hidden page-header pt-40 tablet:pt-36 mobile:pt-32 pb-20 tablet:pb-16 px-6 mobile:px-4">
        <div
          className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_at_center,#000_25%,transparent_70%)]"
          aria-hidden="true"
        ></div>
        <div className="relative container-page">
          <span className="kicker mb-4 animate-fade-in">{t("products.label")}</span>
          <h1 className="text-5xl tablet:text-4xl mobile:text-3xl font-semibold tracking-[-0.02em] text-black leading-[1.05] max-w-3xl animate-slide-up">
            {t("products.title")}
          </h1>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-24 tablet:py-20 px-6 mobile:px-4 bg-white">
        <div className="container-page">
          <h2 className="sr-only">{t("products.label")}</h2>
          <div className="grid grid-cols-3 tablet:grid-cols-1 gap-6">
            {products.map((product) => {
              const Icon = product.icon;
              return (
                <Link
                  key={product.key}
                  to={`/products/${product.key}`}
                  className="group flex flex-col rounded-xl border border-line bg-white p-8 transition-[border-color,box-shadow,transform] duration-300 hover:border-textBlue hover:shadow-lift hover:-translate-y-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-textBlue focus-visible:ring-offset-2"
                >
                  <span className={`${product.bgColor} w-12 h-12 rounded-xl flex items-center justify-center mb-5`}>
                    <Icon className={`w-6 h-6 ${product.color}`} aria-hidden="true" />
                  </span>
                  <h3 className="text-lg font-semibold text-black mb-2 tracking-[-0.01em]">
                    {t(`products.${product.key}.title`)}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-1 line-clamp-3">
                    {t(`products.${product.key}.description`)}
                  </p>
                  <span className="inline-flex items-center gap-2 text-sm font-medium text-textBlue">
                    {t("products.viewMore")}
                    <ArrowRight
                      className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1"
                      aria-hidden="true"
                    />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <ContactCTA />
      <Footer />
    </>
  );
}
